import { render, staticRenderFns } from "./ChaveSeguranca.vue?vue&type=template&id=2a86a666"
import script from "./ChaveSeguranca.vue?vue&type=script&lang=js"
export * from "./ChaveSeguranca.vue?vue&type=script&lang=js"
import style0 from "./ChaveSeguranca.vue?vue&type=style&index=0&id=2a86a666&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports